export default __webpack_public_path__ + "static/shipping-5-4872711987c5af020f69319bb03f9252.jpg";